"use client";
import React, { useEffect, useState } from "react";
import { requestGetGoodsCategory } from "@/lib/api/goods-categories";
import GoodsCategory from "./goods-category";
import Menu from "@/components/header/menu/menu";
import CategoryList from "@/components/header/menu/category-list";
import { GoodsCategoriesItemInterface } from "@/lib/type/goods-categories.type";

export default function MenuPage() {
    const [goodsCategories, setGoodsCategories] = useState<{ list: GoodsCategoriesItemInterface[] } | null>(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await requestGetGoodsCategory({ with_products: "0" });
                setGoodsCategories(response.data);
            } catch (error) {
                console.error("获取商品分类失败:", error);
            }
        };
        fetchData();
    }, []);

    return <div className="w-full bg-white">
        <div className="container bg-white">
            {goodsCategories && <CategoryList data={goodsCategories}></CategoryList>}
        </div>
    </div>;
}


